import axios from 'axios';

const headers = {
    'Content-Type': 'application/json'
}

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: headers
});

export const Api = {
    GET_PAYMENT_REQUEST: (payload) => axiosInstance.post('/paymentrequest', payload)
};

export default Api;